<!--
  * @Author: wangxiaoheng
  * @Date: 2023-01-09 15:14:52
 * @LastEditors: wangxiaoheng
 * @LastEditTime: 2023-07-10 18:06:17
 * @FilePath: \megagame_web\src\views\mine\codeConfirm.vue
  * @Description: 
  * 
  * 
 -->
 <template>
  <div class="my-codeConfirm">
    <div class="confirm" v-if="searchShow">
      <div class="confirmBg"></div>
      <div class="confirm-cord">
        <div class="confirm-info">
          <div class="info-title">报名服务单位：</div>
          <div class="info-value">{{registerName}}</div>
          <div class="info-title info-title2">报名活动：</div>
          <div class="info-value">{{activityName}}</div>
        </div>
        <div class="confirm-search">
          <div class="overallLeft search-title">请填写以下信息完成参赛认证</div>
          <div class="search-key">参赛人员姓名：</div>
          <van-field v-model="username" placeholder="请输入姓名" input-align="right" :disabled='isedit'/>
          <div class="search-key">参赛人员性别：</div>
          <van-field :value="sex" placeholder='请选择性别' readonly @click="isedit?'':showGender=true" input-align="right" :disabled='isedit'/>
          <div class="overallCenter searchBtn" @click="getsearch">
            检索报名信息
          </div>
        </div>
      </div>
      <van-popup v-model="showGender" position="bottom">
        <van-picker show-toolbar :columns="genderArr" @confirm="onConfirm" @cancel="showGender = false"/>
      </van-popup>
    </div>
    <div class="search-result" v-else>
      <div class="result-top">
        为您检索到<span class="result-top-Nub">{{babyList.length}}</span>条报名信息<br> 
        请您在核实信息后，为自己孩子的作品完成参赛确认<br>
        请勿确认他人作品
      </div>
      <div class="baby">
        <div class="baby-card" v-for="(time,index) in babyList" :key="index">
          <div class="overallbaseline baby-card-value">
            <div class="baby-card-value-title">姓名：</div>
            <div class="baby-card-value-key">{{time.babyName}}</div>
          </div>
          <div class="overallbaseline baby-card-value">
            <div class="baby-card-value-title">性别：</div>
            <div class="baby-card-value-key">{{time.babySex==1?'男':'女'}}</div>
          </div>
          <div class="overallbaseline baby-card-value">
            <div class="baby-card-value-title">组别：</div>
            <div class="baby-card-value-key">{{time.groupName}}</div>
          </div>
          <div class="overallbaseline baby-card-value">
            <div class="baby-card-value-title">专业：</div>
            <div class="baby-card-value-key">{{time.majorName}}</div>
          </div>
          <div class="overallbaseline baby-card-value">
            <div class="baby-card-value-title">作品：</div>
            <div></div>
          </div>

          <div class="idTab" v-for="(ks,index) in time.imgsArr" :key="index">
            <div class="overallBetween">
              <div class="fileName">{{ks.fileType==1?'图片':ks.fileType==2?'音频':ks.fileType==3?'视频':ks.fileType==4?'文档':''}}文件： {{ks.fileName}}</div>
              <a style="color: rgb(55, 117, 246)" @click.stop="getcheck(ks)">查看</a>
            </div>
          </div>

          <!-- <div class="works">
            <img  style="height: 140px;" v-if="time.urlType == 1" :src="time.imgs" alt="" />
            <audio v-if="time.urlType == 2" width="100%" height="200" controls :src="infos.imgs"></audio>
            <video v-if="time.urlType == 3"  width="100%" height="200" controls :src="infos.imgs"></video>
            <a style="font-size: 18px; color: #16d77a" v-if="time.urlType == 4" :href="time.imgs">
              点击查看文档类作品
            </a>
          </div> -->
          <div class="overallCenter Submit" @click="getSubmit(time)">信息无误，确认参赛</div>
          <div class="tip">如信息有误，请及时联系报名机构</div>
        </div>
      </div>
    </div>
    <van-popup v-model="checkType" class="photo-tags" closeable position="bottom" :style="{ height: '100%', width: '100%' }" @close="beforeCloseHandler(checkData.fileType)">
      <div class="show-photo-tags">
        <img v-if="checkData.fileType == 1" :src="checkData.fileUrl" alt="" />
        <audio ref="audioPlayer" v-if="checkData.fileType == 2" width="100%" height="200" controls :src="checkData.fileUrl"></audio>
        <video ref="videoPlayer" v-if="checkData.fileType == 3"  width="100%" height="200" controls :src="checkData.fileUrl"></video>
        <p style="text-align: center; margin-top: 20px">
          <a style="font-size: 18px; color: #16d77a" v-if="checkData.fileType == 4" :href="checkData.fileUrl">
            点击查看文档类作品
          </a>
        </p>
      </div>
    </van-popup>
    <van-popup v-model="showCompletion" position="bottom" round>
      <div class="perfect">
        完善参赛学员信息
      </div>
      <van-field input-align="right" readonly clickable :value="cardType"
        name="cardType" label="证件类型" placeholder="点击选择证件类型" @click="showtypeSelect"
      />
      <van-popup v-model="showtypePicker" position="bottom">
        <van-picker show-toolbar @confirm="ontypeConfirm" @cancel="showtypePicker = false"
          :columns="[
            {text: '大陆',value: 0},
            {text: '非大陆',value: 1}
          ]"
        />
      </van-popup>
      <van-field
        input-align="right"
        v-model="bindWorksValue.idCardNo"
        label="证件号码"
        :maxlength="bindWorksValue.idCardType==0?18:null"
        placeholder="证件号码"
      />
      <div class="Tips">提示：建议填写证件信息，保障个人信息完整准确，非强制收集</div>
      <van-field required input-align="right" readonly clickable :value="bindWorksValue.birthday"
        name="cardType" label="学员年龄" placeholder="点击选择出生年月" @click="showBirthday=true"
      />
      <van-popup v-model="showBirthday" position="bottom">
        <van-datetime-picker
          v-model="birthday"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showBirthday = false"
          @confirm="getbirthday"
        />
      </van-popup>
      <div class="overallCenter Submit" @click="getbindWorks(true)">确认并提交</div>
    </van-popup>
  </div>
</template>

<script>
import { bindWorkList,bindWorks,getDetail,getswActivityDetail ,getAllUserBaby} from "@/utils/api/user";
import { getfileTypeArr } from "@/utils/tool";
export default {
  data() {
    return {
      activityId:'',
      activityName:'',
      action:'',
      registerCode:'',
      registerName:'',

      showGender:false,
      sex:'',
      sexVal:null,
      username:'',
      genderArr:[
        {
          text: '男',
          value: 1
        },
        {
          text: '女',
          value: 2
        }
      ],
      isedit:false,
      babyList2:[],
      searchShow:true, 
      babyList: [],

      showCompletion:false,

      showtypePicker:false,
      cardType:'',
      showBirthday:false,
      maxDate: new Date(),
      minDate: new Date(),
      birthday:'',
      bindWorksValue:{
        // 选手/宝贝 出生年月日
        birthday:'',
        // 作品Id
        id:'',
        // 宝贝身份证号码
        idCardNo:'',
        // 身份证类型 0 大陆身份证 1 非大陆身份证
        idCardType:''
      },
      idCardNo:'',
      checkType:false,
      checkData:{},
    };
  },
  mounted() {
    this.registerCode = this.$route.query.registerCode;
    this.action =  this.$route.query.action;
    this.activityId =  this.$route.query.activityId;
    // this.registerCode = this.$route.query.registerCode||'4JICNS'||'6HG546'||'4JICNS'||'XCX9F3';
    // this.action =  this.$route.query.action||'parentConfirm';
    // this.activityId =  this.$route.query.activityId||26;
    if(this.activityId&&this.action&&this.registerCode){
      this.getinformation();
      this.getMybaby();
    }else{
      this.$root.$toast.fail("非法进入，请扫码进入该页面");
    }
  },
  methods: {
    /**
     * @description:  查看文件
     * @param {*} ks
     * @return {*}
     * @author: wangxiaoheng
     */
     getcheck(ks){
      this.checkData = ks;
      this.checkType = true;
    },
    // 获取学生列表
    getMybaby() {
      getAllUserBaby().then((res) => {
        if (res.success) {
          this.babyList2 = res.data.map((e) => {
            return {
              name: e.name,
              age: e.age,
              sex: e.sex,
              organization: e.institutionName || "暂无报名服务单位",
              img: e.imgUrl,
              id: e.id
            };
          });
          if(this.babyList2.length>0){
            this.username = res.data[0].name;
            this.sex = res.data[0].sex == 1?'男':'女';
            this.sexVal = res.data[0].sex;
            this.isedit = true;
          }
        }
      });
    },
    /**
     * @description: 关闭音视频
     * @param {*} index
     * @author: wangxiaoheng
     */
     beforeCloseHandler(){
      if(this.$refs.audioPlayer){
        this.$refs.audioPlayer.pause();
        this.$refs.audioPlayer.currentTime = 0;
      }
      if(this.$refs.videoPlayer){
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
      }
    },
    /**
     * @description: 获取信息--后台两个名称非要写俩接口
     * @author: wangxiaoheng
     */
    getinformation() {
      /**
       * @description: 获取机构姓名
       * @author: wangxiaoheng
       */
      getDetail(this.registerCode).then(res=>{
         if(res.code == 20000){
           this.institutionId = res.data.id;
           this.registerName = res.data.name;
         }
      })
      /**
       * @description: 获取活动信息
       * @author: wangxiaoheng
       */
      getswActivityDetail(this.activityId).then(res=>{
        if(res.code == 20000){
          this.activityName = res.data.name
        }
      })

    },
    // 性别选择确定
    onConfirm(item) {
      this.sex = item.text;
      this.sexVal = item.value;
      this.showGender = false;
    },
    /**
     * @description: 搜索
     * @author: wangxiaoheng
     */
    getsearch(){
      if(!this.username){
        return this.$root.$toast.fail("请输入姓名");
      }
      bindWorkList({
        institutionId:this.institutionId,
        activityId:this.activityId,
        username:this.username,
        sex:this.sexVal,
      }).then((res) => {
        if (res.success && res.data) {
          if(res.data.length>0){
            this.babyList = res.data.map(k=>{
              k.imgsArr = getfileTypeArr(k.imgs)
              return k 
            });
            this.searchShow = false
          }else{
            this.$root.$toast.fail("该姓名没有搜索到数据，请重新搜索");
          }
        } else {
          this.$root.$toast.fail("搜索报错");
        }
      });
    },
    /**
     * @description: 确认参赛
     * @author: wangxiaoheng
     */
    getSubmit(time){
      let date = new Date()
      let Y = date.getFullYear();
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
      let D = (date.getDate() < 10 ? '0'+date.getDate(): date.getDate());
      this.minDate = new Date((Y-30), M, D)
      this.bindWorksValue = {
        // 选手/宝贝 出生年月日
        birthday:time.babyBirthday,
        // 作品Id
        id:time.id,
        // 宝贝身份证号码
        idCardNo:time.babyIdCardNo,
        // 身份证类型 0 大陆身份证 1 非大陆身份证
        idCardType:''
      }
      this.idCardNo = time.babyIdCardNo;
      if(!this.bindWorksValue.birthday||!this.bindWorksValue.id||!this.bindWorksValue.idCardNo){
        this.birthday = time.babyBirthday? new Date(time.babyBirthday)  : new Date(Y, M, D);
        this.bindWorksValue.birthday = time.babyBirthday? time.babyBirthday  : Y+'-'+M+'-'+D,
        this.showCompletion = true;
      }else{
        this.cardType = '大陆';
        this.bindWorksValue.idCardType = 0
        this.getbindWorks(false)
      }
    },
    showtypeSelect() {
      this.showtypePicker = true;
    },
    getbirthday(e){
      let date = new Date(e)
      let Y = date.getFullYear();
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
      let D = (date.getDate() < 10 ? '0'+date.getDate(): date.getDate());
      this.birthday = date;
      this.bindWorksValue.birthday = Y+'-'+M+'-'+D
      this.showBirthday = false;
    },
    ontypeConfirm(item){
      this.cardType = item.text;
      this.bindWorksValue.idCardNo = null;
      this.bindWorksValue.idCardType = item.value;
      this.showtypePicker = false;
    },
    /**
     * @description: 提交绑定作品
     * @author: wangxiaoheng
     */
    getbindWorks(type){
      if(this.bindWorksValue.idCardNo||this.bindWorksValue.idCardType===0||this.bindWorksValue.idCardType===1){
        if((this.bindWorksValue.idCardType==0||this.bindWorksValue.idCardType)&&!this.bindWorksValue.idCardNo){
          return this.$root.$toast.fail("请输入证件号");
        }
        if(this.bindWorksValue.idCardNo&&(this.bindWorksValue.idCardType!=0&&!this.bindWorksValue.idCardType!=1)){
          return this.$root.$toast.fail("请选择证件类型");
        }
      }
      let bindWorksValue = JSON.parse(JSON.stringify(this.bindWorksValue));
      if(!type){
         bindWorksValue.idCardNo = '';
      }else{
         bindWorksValue.idCardNo = this.idCardNo == bindWorksValue.idCardNo?'':bindWorksValue.idCardNo;
      }
      if(!this.bindWorksValue.birthday){
        return this.$root.$toast.fail("绑定失败请选择学员年龄");
      }
      bindWorks(bindWorksValue).then((res) => {
        if (res.success && res.code==20000) {
           this.showCompletion = false
           this.searchShow = true;
           this.$root.$toast.success("绑定成功");
            this.$router.push({
              path: "/home/activity",
            });
        } else {
          this.showCompletion = true;
          let left = this
          setTimeout(()=>{
            left.$root.$toast.fail("绑定失败:"+res.data||res);
          },1)
        }
      });
    },
    editBaby(id) {
      this.$router.push({
        path: "/player/addbaby",
        query: {
          id,
          mode: 1
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.my-codeConfirm {
  box-sizing: border-box;
  padding-top: 1px;
  background: #F7F7FA;
  min-height: 100vh;
  .confirm{
    height: 100vh;
  }
  .confirmBg{
    width: 375px;
    height: 112px;
    background: linear-gradient(180deg, #FFFFFF 0%, #83E38F 0%, rgba(131,227,143,0) 100%);
  }
  .confirm-cord{
    transform: translateY(-93px);
  }
  .confirm-info{
    width: 345px;
    min-height: 121px;
    background: #FFFFFF;
    border-radius: 6px;
    margin: 0 auto;
    padding: 15px;
    .info-title{
      margin-bottom: 5px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      color: #8E8E94;
    }
    .info-title2{
      margin-top: 10px;
    }
    .info-value{
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      text-align: left;
      color: #404046;
    }
  }
  .confirm-search{
    width: 345px;
    height: 461px;
    background: #FFFFFF;
    border-radius: 6px;
    margin: 0 auto;
    margin-top: 15px;
    padding: 0 15px;
    .search-title{
      height: 38px;
      border-bottom: 1px solid #E9E9E9;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FF7856;
    }
    .search-key{
      margin-top: 40px;
      padding-left: 5px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #404046;
      text-align: left;
    }
    .searchBtn{
      width: 186px;
      height: 40px;
      background: #83E38F;
      border-radius: 20px;
      margin: 0 auto;
      margin-top: 70px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
    }
  }
  .search-result{
    .result-top{
      width: 345px;
      height: 80px;
      background: #FFF3E8;
      border-radius: 5px;
      margin: 0 auto;
      margin-top: 16px;
      padding-top: 14px;
      padding-left: 14px;
      text-align: left;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #404046;
      line-height: 20px;
    }
    .result-top-Nub{
      color: #FF7856;
      padding: 0 3px;
    }
  }
  .baby{
    padding-bottom: 10px;
    .baby-card{
      box-sizing: border-box;
      width: 345px;
      min-height: 196px;
      background: #FFFFFF;
      border-radius: 5px;
      margin:0 auto;
      margin-top: 15px;
      padding: 1px 14px;
      padding-bottom: 10px;
    }
    .baby-card-value{
      margin-top: 11px;
    }
    .baby-card-value-title{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #8E8E94;
    }
    .baby-card-value-key{
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #404046;
    }
    .works{
      // width: 230px;
      height: 140px;
      border-radius: 5px;
      margin: 0 auto;
      margin-top: 10px;
    }
    .Submit{
      width: 209px;
      height: 35px;
      background: #83E38F;
      border-radius: 18px;
      margin: 0 auto;
      margin-top: 15px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
    }
    .tip{
      margin-top: 10px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #569FFF;
      line-height: 15px;
      text-align: center;
    }
  }
}
.Tips{
  padding: 10px 16px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #404046;
  text-align: left;
}
.Submit{
  width: 110px;
  height: 35px;
  background: #83E38F;
  border-radius: 18px;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}
.perfect{
  height: 40px;
  text-align: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #404046;
  line-height: 40px;
}
.idTab{
  padding: 2px 4px;
  font-size: 12px;
}
.fileName{
  width: 250px;
  text-align: left;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
</style>
<style lang="scss">
.van-popup.photo-tags {
  background-color: unset;
  .checkClass{
    width: 8.1067rem;
    border-radius: 0.4267rem;
    overflow: hidden;
    margin-top: 5vh;
    display: flex;
  }
  .show-photo-tags {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    p {
      font-size: 14px;
      text-align: center;
      color: #f2f2f2;
    }
    img {
      width: 304px;
      border-radius: 16px;
      overflow: hidden;
      margin-top: 5vh;
      display: flex;
    }
  }
}
</style>
